import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Clipboard } from '@angular/cdk/clipboard';
import { ProfileService, NotificationService } from '@core';
import { API_ResponseStatus } from 'src/app/core/config/api-response.config';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';



@Component({
    selector: 'app-secret-key-generator',
    templateUrl: './secret-key-generator.component.html',
    styleUrls: ['./secret-key-generator.component.less'],
    standalone: false
})
export class SecretKeyGeneratorComponent implements OnInit {
  @ViewChild('downloadLink') downloadLink: ElementRef | undefined;
  secretKeyForm!: FormGroup;
  showForm: boolean = false;
  loading: boolean = false;
  canCopyKey: boolean = false;
  hasSecretKey: boolean = false;
  newKey: boolean = false;
  jsonUrl: string = 'https://docs.waec.org/';


  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private notify: NotificationService,
    private clipboard: Clipboard,
    private modal: NzModalService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.buildSecretKeyForm()
    this.getSecretKey()
  }

  buildSecretKeyForm() {
    this.secretKeyForm = this.fb.group({
      secret_key: [null]
    })
  }

  get secret_key() {
    return this.secretKeyForm.controls['secret_key'].value;
  }

  getSecretKey() { 
    this.profileService
      .getSecretKey()
      .then((res) => {
        if (res?.status === API_ResponseStatus.FAILED) {
          this.notify.error('', res?.message);
          return
        }
        if(res?.data !== null) {
          this.hasSecretKey = true;
          this.canCopyKey = false;
          this.secretKeyForm.patchValue({
            secret_key: "*".repeat(58).concat(res?.data?.last_six_characters)
          })
        } 
        this.showForm = true
      })
      .catch((err) => {
        console.error(err?.error?.message)
      })
  }
  
  generateSecretKey() {
    this.loading = true;

     this.profileService
      .generateSecretKey()
       .then((res) => {
        if (res?.status === API_ResponseStatus.FAILED) {
          this.notify.error('', res?.message);
          return
        }
        this.notify.success('', res?.message);
        this.loading = false;
        this.canCopyKey = true;
        this.secretKeyForm.patchValue({
          secret_key: res?.data
        })         
      })
      .catch((err) => {
        console.error(err?.error?.message)
      })
  }

  copyKey() {    
    this.clipboard.copy(this.secretKeyForm.value?.secret_key);
    this.notify.success('', this.translate.instant("PROFILE.SECRET-KEY-GENERATOR.COPIED_TO_CLIPBOARD"));
  }

  showConfirm() {
    this.modal.confirm({
      nzTitle: this.translate.instant("PROFILE.SECRET-KEY-GENERATOR.GENERATE_NEW_API_KEY"),
      nzContent: this.translate.instant("PROFILE.SECRET-KEY-GENERATOR.CONFIRM_NEW_KEY_GENERATION"),
      nzOkText: this.translate.instant("GENERAL.YES"),
      nzOkType: 'primary',
      nzOnOk: ()=> this.generateSecretKey(),
      nzCancelText: this.translate.instant("GENERAL.NO")
    })
  }

  fetchJSON() {
    this.profileService.downloadAPIcollection().then((res: any) => {
      if (res?.status === API_ResponseStatus.FAILED) {
        this.notify.error('', res?.message);
        return
      }
      this.notify.success('', this.translate.instant("PROFILE.SECRET-KEY-GENERATOR.COLLECTION_DOWNLOADED_SUCCESSFULLY"));
      this.downloadFile(res.collection);
    })
    .catch((err) => {
      console.error(err?.error?.message)
    })
  }

  downloadFile(data: any) {
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'collection.json';
    a.click();

    window.URL.revokeObjectURL(url);
  }

}
